import { defineComponent as _defineComponent } from 'vue'
import { computed, WritableComputedRef } from 'vue'
import SelectBox from './SelectBox.vue';

type Item = {
  text: string,
  value:  string,
}

type Props = {
  value: Item,
  disabled?: boolean,
  items: Item[],
  appendText: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SortDropDown',
  props: {
    value: null,
    disabled: { type: Boolean },
    items: null,
    appendText: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: Item): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: Item,
  disabled?: boolean,
  items: Item[],
  appendText: string,
};




const selectedItem: WritableComputedRef<Item> = computed({
  get(): Item {
    return props.value;
  },
  set(newValue: Item): void {
    if(props.value.value !== newValue.value) {
      emit("input", newValue);
    }
  },
});


return { __sfc: true,props, emit, selectedItem, SelectBox }
}

})